import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { toaster } from "../../utils/utils";
import apiConstants from "../../constans/apiConstants";
import DataTable from "../../components/Table/index";
import {
  getPSMaction,
  psmDeletePoposal,
  psmPoposal,
} from "../../store/actions/psmAction";
import { getProductList } from "../../store/actions/productConfigActions";
import MobilePopUp from "../../components/MobilePopUp/MobilePopUp";

const PSM_Matrix = (props) => {
  const dispatch = useDispatch();
  let userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const productList = useSelector(
    (state) => state?.productTypeData?.productList
  );
  const statusPanON = useSelector(
    (state) => state?.switchApiReducer?.switchApiData?.waiveOffMedicalsPanIndia
  );

  const [showEditModal, setshowEditModal] = useState(false);
  const [showLifeAssured, setshowLifeAssured] = useState(false);
  const [mainData, setMainData] = useState({
    id: "",
    minAge: "",
    maxAge: "",
    minHouseholdIncome: "",
    maxHouseholdIncome: "",
    need: "",
    plan: "",
    channel: "",
    subChannel: "",
    sourceValue:"",
    occupation: "",
    proposalGender:"",
    maritalStatus: "",
    numChildren: "",
    riskType: "",
    lifeInsuredMinAge: "",
    lifeInsuredMaxAge: "",
    lifeInsuredGender: "",
    policyFor: "",
  });
  const [psmData, setPSMData] = useState([]);
  const [data, setData] = useState();
  const [showDeleteModal, setshowDeleteModal] = useState(false);
  const [modalData, setModalData] = useState({});
  const [showCancelBtn, setShowCancelBtn] = useState(false);
  const needs = [
    {
      code: 1,
      val: "",
      text: "Retirements",
    },
    {
      code: 2,
      val: "",
      text: "Child Education And Marriage",
    },
    {
      code: 3,
      val: "",
      text: "Protection",
    },
    {
      code: 4,
      val: "",
      text: "Savings",
    },
    {
      code: 5,
      val: "",
      text: "Wealth Creation",
    },
    {
      code: 6,
      val: "",
      text: "Income",
    },
    // {
    //   code: 7,
    //   val: "",
    //   text: "Wealth creation / savings",
    // },
  ];
  const risk = [
    {
      code: 1,
      val: "AGGRESSIVE",
      text: "Aggressive - High Risk taking ability",
    },
    {
      code: 2,
      val: "BALANCED",
      text: "Balanced - Moderate Risk taking ability",
    },
    {
      code: 3,
      val: "CONSERVATIVE",
      text: "Conservative - Low Risk taking ability",
    },
  ];
  const policyFor = [
    {
      code: 1,
      val: "SELF",
      text: "Self",
    },
    {
      code: 2,
      val: "OTHER",
      text: "Other",
    },
    // {
    //   code: 3,
    //   val: "JOINT_LIFE",
    //   text: "Joint LIfe",
    // },
  ];
  const noOfChildren = [
    {
      code: 1,
      val: 0,
      text: "0",
    },
    {
      code: 2,
      val: 1,
      text: "More than / equal to 1",
    },
  ];

  const maritalStatus = [
    {
      code: 1,
      val: "S",
      text: "Single",
    },
    {
      code: 2,
      val: "M",
      text: "Married",
    },
    {
      code: 3,
      val: "W",
      text: "Widowed",
    },
    {
      code: 4,
      val: "D",
      text: "Divorced",
    },
  ];

  const lfGender = [
    {
      code: 1,
      val: "MALE",
      text: "MALE",
    },
    {
      code: 2,
      val: "FEMALE",
      text: "FEMALE",
    },
    {
      code: 3,
      val: "TRANSGENDER",
      text: "TRANSGENDER",
    }
  ];

  const proposerOccupation = [
    {
      code: 1,
      val: "STUDENT",
      text: "Student",
    },
    {
      code: 2,
      val: "RETIRED",
      text: "Retired",
    },
    {
      code: 3,
      val: "BUSINESS",
      text: "Business/Self Employed",
    },

    {
      code: 4,
      val: "SALARIED",
      text: "Salaried",
    },
    {
      code: 5,
      val: "PROFESSIONAL",
      text: "Professional",
    },
    {
      code: 6,
      val: "HOUSEWIFE",
      text: "Housewife",
    },
    {
      code: 7,
      val: "AGRICULTURIST",
      text: "Agriculturist",
    },
    {
      code: 8,
      val: "PARAMILITARY",
      text: "Paramilitary",
    },
    {
      code: 9,
      val: "DEFENCE",
      text: "Defence",
    },
    {
      code: 10,
      val: "HOUSEWIFE",
      text: "Housewife",
    },
    {
      code: 11,
      val: "AGRICULTURIST",
      text: "Agriculturist",
    },
    {
      code: 12,
      val: "SELFEMPLOYED",
      text: "Self Employed",
    },
    {
      code: 13,
      val: "PARAMILITARYDEFENSE",
      text: "Paramilitary/Defence",
    },
    {
      code: 14,
      val: "NONE",
      text: "NONE",
    },
  ];
const needText=(code)=>{
 const needWithCodeText = needs.find((need) => need.code === Number(code));
  return needWithCodeText?.text || "";
}
  useEffect(() => {
    // Fetch the API data

    dispatch(
      getPSMaction((response) => {
          setPSMData(
              response.body.map((item) => ({
                id: item.id,
                minAge: item.minAge,
                maxAge: item.maxAge,
                minHouseholdIncome: item.minHouseholdIncome + " " + "lakh",
                maxHouseholdIncome: item.maxHouseholdIncome + " " + "lakh",
                // need: needWithCodeText.text,
                need: needText(item.need),
                plan: item.plan,
                channel: item.channel,
                subChannel: item.subChannel,
                cabPartnerName:item.cabPartnerName,
                // channel: item.channel === "ALL_VALUES" ? "All" : item.channel,
                // subChannel:
                //   item.subChannel === "ALL_VALUES" ? "All" : item.subChannel,
                // cabPartnerName:
                //   item.cabPartnerName === "ALL_VALUES"
                //     ? "All"
                //     : item.cabPartnerName,
                occupation: item.occupation,
                proposalGender:item.proposalGender,
                maritalStatus: item.maritalStatus,
                numChildren: item.numChildren === 1 ? ">=1" : 0,
                riskType: item.riskType,
                lifeInsuredMinAge:
                  item.policyFor === "SELF" ? null : item.lifeInsuredMinAge,
                lifeInsuredMaxAge:
                  item.policyFor === "SELF" ? null : item.lifeInsuredMaxAge,
                lifeInsuredGender:
                  item.policyFor === "SELF" ? null : item.lifeInsuredGender,
                policyFor: item.policyFor,
              }))
            )
      })
    );
  }, []);

  useEffect(() => {
    getAllItem(); // get source/ channel/ partner list
  }, []);

  useEffect(() => {
    dispatch(getProductList()); // get product list
  }, []);

  // souce / channel/ partner list
  const getAllItem = () => {
    const param = `partnerName=${mainData.partnerValue}&subChannel=${mainData.subChannel}&channel=${mainData.channel}&sources=${mainData.sourceValue}`;
    const queryParam = !param
      ? param
      : "partnerName&subChannel&channel&sources";
    axios
      .get(
        `${
          apiConstants().PROPOSEL_API_URL
        }api/v1/proposal/instaVerify/instaRuleSheet?${queryParam}
      `,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("token"),
          },
        }
      )
      .then((res) => {
        dispatch({ type: "LOADER_FALSE" });
        if (res && res.data) {
          setData(res?.data?.body);
          // toaster("success", res.data.message);
        }
      })
      .catch((err) => {
        dispatch({ type: "LOADER_FALSE" });
        if (err && err.data) {
          // toaster("error", err.data.message);
        }
      });
  };

  const getUniqueListBy = (array, key) => {
    return [
      ...new Map(
        array
          ?.filter(
            (item) =>
              item[key] &&
              item[key].toString().trim() !== "" &&
              item[key] !== "0"
          )
          .map((item) => [item[key].trim().toLowerCase(), item])
      ).values(),
    ];
  };

  const plan = getUniqueListBy(productList, "productName").map((item) => ({
    id: item.productId,
    text: item.productName,
  }));

  const sourceList = getUniqueListBy(data, "sources")?.map((item) => ({
    id: item.id,
    text: item.sources,
  }));

  const filteredChannelList = data?.filter(
    (item) => item.sources === mainData.sourceValue
  );
  const channelList = getUniqueListBy(filteredChannelList, "channel")?.map(
    (item) => ({
      id: item.id,
      text: item.channel,
    })
  );

  const filteredsubPartner = data?.filter(
    (item) => item.channel === mainData.channel
  );
  const subPartnerList = getUniqueListBy(filteredsubPartner, "subChannel")?.map(
    (item) => ({
      id: item.id,
      text: item.subChannel,
    })
  );

  const filteredPartner = data?.filter(
    (item) => item.subChannel === mainData.subChannel
  );
  const partnerList = getUniqueListBy(filteredPartner, "partnerName")?.map(
    (item) => ({
      id: item.id,
      text: item.partnerName,
    })
  );

  // handleChange
  const handleChange = (event, detail) => {
    const { value } = event.target;

    if (detail === "policyFor" && value === "OTHER") {
      setshowLifeAssured(true);
    } else if (detail === "policyFor" && value === "SELF") {
      setshowLifeAssured(false);
    }

    setMainData((prevData) => {
      let updatedData = { ...prevData, [detail]: value };

      if (value === "ALL_VALUES") {
        if (detail === "sourceValue") {
          updatedData.channel = "ALL_VALUES";
          updatedData.subChannel = "ALL_VALUES";
          updatedData.partnerValue = "ALL_VALUES";
        } else if (detail === "channel") {
          updatedData.subChannel = "ALL_VALUES";
          updatedData.partnerValue = "ALL_VALUES";
        } else if (detail === "subChannel") {
          updatedData.partnerValue = "ALL_VALUES";
        }
      }

      return updatedData;
    });
  };

  // final form submit
  const finalSubmit = () => {
    let data;
    let devData;

    data = {
      minAge: mainData.minAge,
      maxAge: mainData.maxAge,
      minHouseholdIncome: mainData.minHouseholdIncome,
      maxHouseholdIncome: mainData.maxHouseholdIncome,
      need: mainData.need,
      plan: mainData.plan,
      channel: mainData.channel,
      subChannel: mainData.subChannel,
      occupation: mainData.occupation,
      proposalGender:mainData.proposalGender,
      maritalStatus: mainData.maritalStatus,
      numChildren: parseInt(mainData.numChildren),
      riskType: mainData.riskType,
      lifeInsuredMinAge:
        mainData.policyFor === "SELF" ? null : mainData.lifeInsuredMinAge,
      lifeInsuredMaxAge:
        mainData.policyFor === "SELF" ? null : mainData.lifeInsuredMaxAge,
      lifeInsuredGender:
        mainData.policyFor === "SELF" ? null : mainData.lifeInsuredGender,
      policyFor: mainData.policyFor,
    };

    devData = {
      minAge: mainData.minAge,
      maxAge: mainData.maxAge,
      minHouseholdIncome: mainData.minHouseholdIncome,
      maxHouseholdIncome: mainData.maxHouseholdIncome,
      need: mainData.need,
      plan: mainData.plan,
      channel: mainData.channel,
      subChannel: mainData.subChannel,
    };

    dispatch(
      psmPoposal(data, (res) => {
        if (
          res.status === "OK" ||
          res.status === "FOUND" ||
          res.status === "CREATED"
        ) {
          const item = res.body;
          const needWithCodeText = needs.find(
            (need) => String(need.code) === item.need
          );
          setPSMData((prev) => [
                ...prev,
                {
                  id: item.id,
                  minAge: item.minAge,
                  maxAge: item.maxAge,
                  minHouseholdIncome: item.minHouseholdIncome + " " + "lakh",
                  maxHouseholdIncome: item.maxHouseholdIncome + " " + "lakh",
                  need: needWithCodeText.text,
                  plan: item.plan,
                  channel: item.channel,
                  subChannel: item.subChannel,
                  occupation: item.occupation,
                  proposalGender:item.proposalGender,
                  maritalStatus: item.maritalStatus,
                  numChildren: item.numChildren,
                  riskType: item.riskType,
                  lifeInsuredMinAge: item.lifeInsuredMinAge,
                  lifeInsuredMaxAge: item.lifeInsuredMaxAge,
                  lifeInsuredGender: item.lifeInsuredGender,
                  policyFor: item.policyFor,
                },
              ])
        }
      })
    );
  };

  // update form values

  const handleUpdateChange = (item) => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    setShowCancelBtn(true);

    if (item.policyFor === "OTHER") {
      setshowLifeAssured(true);
    } else if (item.policyFor === "SELF") {
      setshowLifeAssured(false);
    }

    let sourceValue = "";

    if (item.channel === "All") {
      const fallback = data.find(
        (d) =>
          d.subChannel === item.subChannel ||
          d.partnerName === item.cabPartnerName
      )?.sources;

      sourceValue = fallback || "ALL_VALUES";
    } else {
      sourceValue = data.find((d) => d.channel === item.channel)?.sources || "";
    }

    // Get channelValue from subChannel

    let channelValue = "";

    if (item.subChannel === "All") {
      const fallback = data.find((d) => d.channel === item.channel)?.channel;

      channelValue = fallback || "ALL_VALUES";
    } else {
      channelValue =
        data.find((d) => d.subChannel === item.subChannel)?.channel || "";
    }

    // Get subChannelValue from cabPartnerName

    let subChannelValue = "";

    if (item.cabPartnerName === "All") {
      const fallback = data.find(
        (d) => (d.channel === d.subChannel) === item.subChannel
      )?.subChannel;

      subChannelValue = fallback || "ALL_VALUES";
    } else {
      subChannelValue =
        data.find((d) => d.partnerName === item.cabPartnerName)?.subChannel ||
        "";
    }
    let minHouseholdIncome = String(item?.minHouseholdIncome || "")
      .replace(/[^0-9.]/g, "")
      .trim();
    let maxHouseholdIncome = String(item?.maxHouseholdIncome || "")
      .replace(/[^0-9.]/g, "")
      .trim();

    const needWithCodeText = needs.find((need) => need.text === item.need);

   setMainData({
          id: item.id,
          minAge: item.minAge,
          maxAge: item.maxAge,
          minHouseholdIncome: minHouseholdIncome,
          maxHouseholdIncome: maxHouseholdIncome,
          need: needWithCodeText.code,
          plan: item.plan,
          channel: item.channel,
          subChannel: item.subChannel,
          occupation: item.occupation,
          proposalGender:item.proposalGender,
          maritalStatus: item.maritalStatus,
          numChildren:item.numChildren === 1 || item.numChildren === ">=1" ? 1 : 0,
          riskType: item.riskType,
          lifeInsuredMinAge: item.lifeInsuredMinAge,
          lifeInsuredMaxAge: item.lifeInsuredMaxAge,
          lifeInsuredGender: item.lifeInsuredGender,
          policyFor: item.policyFor,
        })
  };

  const updateTPAData = () => {
    let data;
    let devData;
    data = {
      id: mainData.id,
      minAge: mainData.minAge,
      maxAge: mainData.maxAge,
      minHouseholdIncome: mainData.minHouseholdIncome,
      maxHouseholdIncome: mainData.maxHouseholdIncome,
      need: mainData.need,
      plan: mainData.plan,
      channel: mainData.channel,
      subChannel: mainData.subChannel,
      occupation: mainData.occupation,
      proposalGender: mainData.proposalGender,
      maritalStatus: mainData.maritalStatus,
      numChildren: mainData.numChildren,
      riskType: mainData.riskType,
      lifeInsuredMinAge: mainData.lifeInsuredMinAge,
      lifeInsuredMaxAge: mainData.lifeInsuredMaxAge,
      lifeInsuredGender: mainData.lifeInsuredGender
        ? mainData.lifeInsuredGender
        : "MALE",
      policyFor: mainData.policyFor,
    };
    devData = {
      id: mainData.id,
      minAge: mainData.minAge,
      maxAge: mainData.maxAge,
      minHouseholdIncome: mainData.minHouseholdIncome,
      maxHouseholdIncome: mainData.maxHouseholdIncome,
      need: mainData.need,
      plan: mainData.plan,
      channel: mainData.channel,
      subChannel: mainData.subChannel,
    };
    dispatch(
      psmPoposal(data , (res) => {
        if (res.status === "OK" || res.status === "FOUND") {
          const item = res.body;
          const needWithCodeText = needs.find(
            (need) => String(need.code) === item.need
          ); 
          setPSMData((prev) => {
                const index = prev.findIndex((entry) => entry.id === item.id);
                if (index !== -1) {
                  // Update the existing item
                  const updated = [...prev];
                  updated[index] = {
                    id: item.id,
                    minAge: item.minAge,
                    maxAge: item.maxAge,
                    minHouseholdIncome: item.minHouseholdIncome + " " + "lakh",
                    maxHouseholdIncome: item.maxHouseholdIncome + " " + "lakh",
                    need: needWithCodeText.text,
                    plan: item.plan,
                    channel: item.channel,
                    subChannel: item.subChannel,
                    occupation: item.occupation,
                    proposalGender:item.proposalGender,
                    maritalStatus: item.maritalStatus,
                    numChildren: item.numChildren === 1 ? ">=1" : 0,
                    riskType: item.riskType,
                    lifeInsuredMinAge:
                      item.policyFor === "SELF" ? "" : item.lifeInsuredMinAge,
                    lifeInsuredMaxAge:
                      item.policyFor === "SELF" ? "" : item.lifeInsuredMaxAge,
                    lifeInsuredGender:
                      item.policyFor === "SELF" ? "" : item.lifeInsuredGender,
                    policyFor: item.policyFor,
                  };
                  return updated;
                } else {
                  // Add new item
                  return [
                    ...prev,
                    {
                      id: item.id,
                      minAge: item.minAge,
                      maxAge: item.maxAge,
                      minHouseholdIncome: item.minHouseholdIncome,
                      maxHouseholdIncome: item.maxHouseholdIncome,
                      need: needWithCodeText.text,
                      plan: item.plan,
                      channel: item.channel,
                      subChannel: item.subChannel,
                      occupation: item.occupation,
                      proposalGender:item.proposalGender,
                      maritalStatus: item.maritalStatus,
                      numChildren: item.numChildren === 1 ? ">=1" : 0,
                      riskType: item.riskType,
                      lifeInsuredMinAge:
                        item.policyFor === "SELF" ? "" : item.lifeInsuredMinAge,
                      lifeInsuredMaxAge:
                        item.policyFor === "SELF" ? "" : item.lifeInsuredMaxAge,
                      lifeInsuredGender:
                        item.policyFor === "SELF" ? "" : item.lifeInsuredGender,
                      policyFor: item.policyFor,
                    },
                  ];
                }
              })
        }
      })
    );
  };

  // delete values
  const deleteData = async (modalData) => {
    try {
      // Dispatch the freezeDateAction and wait for it to complete
      await dispatch(
        psmDeletePoposal(modalData, (res) => {
          setPSMData((prev) => prev.filter((item) => item.id !== modalData.id));
          setshowDeleteModal(false);
        })
      );
    } catch (error) {
      console.error("Error during saving:", error);
    }
    cancelHandler();
  };

  const cancelHandler = () => {
    setShowCancelBtn(false);
  setMainData({
          minAge: "",
          maxAge: "",
          minHouseholdIncome: "",
          maxHouseholdIncome: "",
          need: "",
          plan: "",
          channel: "",
          subChannel: "",
          sourceValue: "",
          partnerValue: "",
          occupation: "",
          proposalGender: "",
          maritalStatus: "",
          numChildren: "",
          riskType: "",
          lifeInsuredMinAge: "",
          lifeInsuredMaxAge: "",
          lifeInsuredGender: "",
          policyFor: "",
        })
  };
  const onChange = (name, value) => {
    // Allow only digits in numeric fields
    const numericFields = [
      "minAge",
      "maxAge",
      "minHouseholdIncome",
      "maxHouseholdIncome",
    ];
    if (numericFields.includes(name) && !/^\d*$/.test(value)) {
      return; // ignore non-numeric input
    }

    setMainData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const isFormValid = () => {
    const {
      minAge,
      maxAge,
      need,
      plan,
      channel,
      subChannel,
      minHouseholdIncome,
      maxHouseholdIncome,
      occupation,
      proposalGender,
      maritalStatus,
      numChildren,
      riskType,
      lifeInsuredMinAge,
      lifeInsuredMaxAge,
      lifeInsuredGender,
      policyFor,
    } = mainData || {};

    const areFieldsFilled =
      
        policyFor === "SELF"
          ? minAge !== "" &&
            maxAge !== "" &&
            need &&
            plan &&
            channel &&
            subChannel &&
            minHouseholdIncome !== "" &&
            maxHouseholdIncome !== "" &&
            occupation &&
            proposalGender &&
            maritalStatus &&
            numChildren &&
            riskType &&
            policyFor
          : minAge !== "" &&
            maxAge !== "" &&
            need &&
            plan &&
            channel &&
            subChannel &&
            minHouseholdIncome !== "" &&
            maxHouseholdIncome !== "" &&
            occupation &&
            proposalGender &&
            maritalStatus &&
            numChildren &&
            riskType &&
            lifeInsuredMinAge !== "" &&
            lifeInsuredMaxAge !== "" &&
            lifeInsuredGender &&
            policyFor

    const isAgeValid = Number(minAge) < Number(maxAge);
    const isLifeAgeValid =
      Number(lifeInsuredMinAge) < Number(lifeInsuredMaxAge);
    const isIncomeValid =
      Number(minHouseholdIncome) < Number(maxHouseholdIncome);
    if (policyFor === "SELF") {
      return areFieldsFilled && isAgeValid && isIncomeValid;
    } else {
      return areFieldsFilled && isAgeValid && isLifeAgeValid && isIncomeValid;
    }
  };

  return (
    <>
      <div className="proposalDetails_comp operations-page__matrix-form">
        <div className="proposalDetail main_container">
          <div className="tpa-block">
            <h1>PSM Matrix</h1>

            <div className="tpa-block-first">
              { (
                <div className="tpa_waive_container">
                  <p className="section">Policy For </p>
                  <select
                    className="form-control custom-dropdown"
                    id="tpaDropdown"
                    value={mainData?.policyFor}
                    onChange={(event) => handleChange(event, "policyFor")}
                  >
                    {policyFor.length && (
                      <option value="" disabled hidden>
                        -- select --
                      </option>
                    )}
                    {policyFor.map((option) => (
                      <option key={option.id} value={option.val}>
                        {option.text}
                      </option>
                    ))}
                  </select>
                </div>
              )}
            </div>

            <div className="tpa-block-second">
              <div className="tpa_container">
                {/* Source */}

                <div className="select-container">
                  <p className="section">Source</p>

                  <select
                    className="form-control custom-dropdown"
                    id="source"
                    value={mainData?.sourceValue}
                    onChange={(e) => handleChange(e, "sourceValue")}
                  >
                    {sourceList.length && (
                    <option value=""  disabled hidden >
                      -- select --
                    </option>)}

                    <option value="ALL_VALUES">All</option>

                    {sourceList?.map((option) => (
                      <option key={option.id} value={option.text}>
                        {option.text}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Channel */}

                <div className="select-container">
                  <p className="section">Channel</p>

                  <select
                    className="form-control custom-dropdown"
                    id="channel"
                    value={mainData.channel}
                    onChange={(e) => handleChange(e, "channel")}
                    disabled={
                      !mainData.sourceValue ||
                      mainData.sourceValue === "ALL_VALUES"
                    }
                  >
                    <option value="" disabled>
                      -- select --
                    </option>

                    <option value="ALL_VALUES">All</option>

                    {channelList?.map((option) => (
                      <option key={option.id} value={option.text}>
                        {option.text}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Sub Channel */}

                <div className="select-container">
                  <p className="section">Sub Channel</p>

                  <select
                    className="form-control custom-dropdown"
                    id="subPartner"
                    value={mainData.subChannel}
                    onChange={(e) => handleChange(e, "subChannel")}
                    disabled={
                      !mainData.sourceValue ||
                      mainData.sourceValue === "ALL_VALUES" ||
                      !mainData.channel ||
                      mainData.channel === "ALL_VALUES"

                      // ||

                      // !mainData.subChannel ||

                      // mainData.subChannel === "ALL_VALUES"
                    }
                  >
                    <option value="" disabled>
                      -- select --
                    </option>

                    <option value="ALL_VALUES">All</option>

                    {subPartnerList?.map((option) => (
                      <option key={option.id} value={option.text}>
                        {option.text}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Partner */}

                <div className="select-container">
                  <p className="section">Partner</p>

                  <select
                    className="form-control custom-dropdown"
                    id="partner"
                    value={mainData.partnerValue}
                    onChange={(e) => handleChange(e, "partnerValue")}
                    disabled={
                      !mainData.sourceValue ||
                      mainData.sourceValue === "ALL_VALUES" ||
                      !mainData.channel ||
                      mainData.channel === "ALL_VALUES" ||
                      !mainData.subChannel ||
                      mainData.subChannel === "ALL_VALUES" ||
                      partnerList.length === 0
                    }
                  >
                    <option value="" disabled>
                      -- select --
                    </option>

                    <option value="ALL_VALUES">All</option>

                    {partnerList?.map((option) => (
                      <option key={option.id} value={option.text}>
                        {option.text}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>

            {/* Life assured  */}

            {/* <h3>Life Assured</h3> */}

            {showLifeAssured && (
              <div className="tpa-block-first">
                <div className="tpa_waive_container">
                  <p className="section">Life Assured Minimum Age</p>

                  <input
                    onChange={(e) => onChange(e.target.name, e.target.value)}
                    value={mainData.lifeInsuredMinAge}
                    className="form-control custom-dropdown"
                    type="text"
                    name="lifeInsuredMinAge"
                    maxLength={2}
                  />
                </div>
                <div className="tpa_waive_container">
                  <p className="section">Life Assured Maximum Age</p>
                  <input
                    onChange={(e) => onChange(e.target.name, e.target.value)}
                    value={mainData.lifeInsuredMaxAge}
                    className="form-control custom-dropdown"
                    type="text"
                    name="lifeInsuredMaxAge"
                    maxLength={2}
                  />
                </div>
                <div className="tpa_waive_container">
                  <p className="section">Life Assured Gender</p>
                  <select
                    className="form-control custom-dropdown"
                    id="lifeInsuredGender"
                    name="lifeInsuredGender"
                    value={mainData.lifeInsuredGender} // should be code like 5
                    onChange={(event) =>
                      handleChange(event, "lifeInsuredGender")
                    }
                  >
                    <option value="" disabled hidden>
                      -- select --
                    </option>
                    {lfGender.map((option) => (
                      <option key={option.code} value={option.val}>
                        {option.text}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            )}
            <div className="tpa-block-first">
              {(
                <>
                  <div className="tpa_waive_container">
                    <p className="section">Proposer Occupation </p>
                    <select
                      className="form-control custom-dropdown"
                      id="occupation"
                      name="occupation"
                      value={mainData.occupation} // should be code like 5
                      onChange={(event) => handleChange(event, "occupation")}
                    >
                      <option value="" disabled hidden>
                        -- select --
                      </option>
                      {proposerOccupation.map((option) => (
                        <option key={option.code} value={option.val}>
                          {option.text}
                        </option>
                      ))}
                    </select>
                  </div>
                   <div className="tpa_waive_container">
                    <p className="section">Proposer Gender </p>
                    <select
                      className="form-control custom-dropdown"
                      id="proposalGender"
                      name="proposalGender"
                      value={mainData.proposalGender} // should be code like 5
                      onChange={(event) => handleChange(event, "proposalGender")}
                    >
                      <option value="" disabled hidden>
                        -- select --
                      </option>
                    {lfGender.map((option) => (
                      <option key={option.code} value={option.val}>
                        {option.text}
                      </option>
                    ))}
                    </select>
                  </div>

                  <div className="tpa_waive_container">
                    <p className="section">Proposer Marital Status </p>
                    <select
                      className="form-control custom-dropdown"
                      id="tpaDropdown"
                      value={mainData?.maritalStatus}
                      onChange={(event) => handleChange(event, "maritalStatus")}
                    >
                      {maritalStatus.length && (
                        <option value="" disabled hidden>
                          -- select --
                        </option>
                      )}
                      {maritalStatus.map((option) => (
                        <option key={option.id} value={option.val}>
                          {option.text}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="tpa_waive_container">
                    <p className="section">No. of children </p>
                    <select
                      className="form-control custom-dropdown"
                      id="tpaDropdown"
                      value={mainData?.numChildren}
                      onChange={(event) => handleChange(event, "numChildren")}
                    >
                      {noOfChildren.length && (
                        <option value="" disabled hidden>
                          -- select --
                        </option>
                      )}
                      {noOfChildren.map((option) => (
                        <option key={option.id} value={option.val}>
                          {option.text}
                        </option>
                      ))}
                    </select>
                  </div>
                </>
              )}
            </div>
            <div className="tpa-block-first">
              <div className="tpa_waive_container">
                <p className="section">Need For </p>
                <select
                  className="form-control custom-dropdown"
                  id="needFor"
                  name="need"
                  value={mainData.need} // should be code like 5
                  onChange={(e) => {
                    const selectedCode = parseInt(e.target.value, 10);
                    onChange(e.target.name, selectedCode);
                  }}
                >
                  <option value="" disabled hidden>
                    -- select --
                  </option>
                  {needs.map((option) => (
                    <option key={option.code} value={option.code}>
                      {option.text}
                    </option>
                  ))}
                </select>
              </div>

              <div className="tpa_waive_container">
                <p className="section">Product Name </p>
                <select
                  className="form-control custom-dropdown"
                  id="tpaDropdown"
                  value={mainData?.plan}
                  onChange={(event) => handleChange(event, "plan")}
                >
                  {plan.length && (
                    <option value="" disabled hidden>
                      -- select --
                    </option>
                  )}
                  {plan.map((option) => (
                    <option key={option.id} value={option.text}>
                      {option.text}
                    </option>
                  ))}
                </select>
              </div>
              {(
                <div className="tpa_waive_container">
                  <p className="section">Risk</p>
                  <select
                    className="form-control custom-dropdown"
                    id="riskType"
                    name="riskType"
                    value={mainData.riskType} // should be code like 5
                    onChange={(event) => handleChange(event, "riskType")}
                  >
                    <option value="" disabled hidden>
                      -- select --
                    </option>
                    {risk.map((option) => (
                      <option key={option.code} value={option.val}>
                        {option.text}
                      </option>
                    ))}
                  </select>
                </div>
              )}
            </div>

            {/* -- */}
            <div className="tpa-block-first">
              <div className="tpa_waive_container">
                <p className="section">Minimum Age</p>
                <input
                  onChange={(e) => onChange(e.target.name, e.target.value)}
                  value={mainData.minAge}
                  className="form-control custom-dropdown"
                  type="text"
                  name="minAge"
                  maxLength={2}
                />
              </div>
              <div className="tpa_waive_container">
                <p className="section">Maximum Age</p>
                <input
                  onChange={(e) => onChange(e.target.name, e.target.value)}
                  value={mainData.maxAge}
                  className="form-control custom-dropdown"
                  type="text"
                  name="maxAge"
                  maxLength={2}
                />
              </div>
              <div className="tpa_waive_container">
                <p className="section">Min Household Income (in lakh) </p>
                <input
                  onChange={(e) => onChange(e.target.name, e.target.value)}
                  value={mainData.minHouseholdIncome}
                  className="form-control custom-dropdown"
                  type="text"
                  name={"minHouseholdIncome"}
                  maxLength={3}
                />
              </div>
              <div className="tpa_waive_container">
                <p className="section">Max Household Income (in lakh)</p>
                <input
                  onChange={(e) => onChange(e.target.name, e.target.value)}
                  value={mainData.maxHouseholdIncome}
                  className="form-control custom-dropdown"
                  type="text"
                  name={"maxHouseholdIncome"}
                  maxLength={3}
                />
              </div>
            </div>

            <div className="tpa-form-btn">
              <button
                className="searchbt tpa-Submit-btn"
                onClick={showCancelBtn ? updateTPAData : finalSubmit}
                disabled={showCancelBtn ? false : !isFormValid()}
              >
                {showCancelBtn ? "Update" : "Submit"}
              </button>
              {showCancelBtn && (
                <button
                  className="searchbt tpa-Submit-btn"
                  onClick={cancelHandler}
                >
                  Cancel
                </button>
              )}
            </div>
          </div>
        </div>
        {/* list */}
      </div>
      { (
        <div className="proposal-dashboard__table-section operations-page__table-section operations-page__matrix-table">
        <DataTable
          cellHeaders={[
            // "Id",
            "Policy For",
            "Life Assured Minimum Age",
            "Life Assured Maximum Age",
            "Life Assured Gender",
            "Proposer Occupation",
            "Proposer Gender",
            "Proposer Marital Status",
            "No. of Children",
            "Risk",
            "Min Age",
            "Max Age",
            "Min Household Income",
            "Max Household Income",
            "Need",
            "Channel",
            "Plan",
            "Sub Channel",
            "",
          ]}
          data={[...psmData].sort((a, b) => b.id - a.id)}
          keys={[
            // "id",
            "policyFor",
            "lifeInsuredMinAge",
            "lifeInsuredMaxAge",
            "lifeInsuredGender",
            "occupation",
            "proposalGender",
            "maritalStatus",
            "numChildren",
            "riskType",
            "minAge",
            "maxAge",
            "minHouseholdIncome",
            "maxHouseholdIncome",
            "need",
            "channel",
            "plan",
            "subChannel",
            "FreezecustomButtons",
          ]}
          fileName="Freeze Data"
          addSerialNo={true}
          onCustomButtonClick={(item) => {
            handleUpdateChange(item);
          }}
          onCustomDeletButtonClick={(item) => {
            setModalData(item);
            setshowDeleteModal(true);
          }}
          convertValueToString={true}
          showExcelDownload={true}
          PerPageApiData={false}
          paginationItems={data}
          alwaysShown={false}
          // onRowClicked={handleRowClicked}
        />
        </div>
      )}

      {showDeleteModal && (
        <MobilePopUp
          onClose={() => {
            setshowDeleteModal(false);
          }}
        >
          <>
            <div>
              <div className="h3 freeze-data-delete-message1">
                Are you sure?
              </div>
              <div className="freeze-data-delete-message2">
                you won't to able revert this!
              </div>
            </div>
            <div className="Freeze-Delete-button-wrapper">
              <button
                className="delte-no-btn custom-button"
                onClick={() => setshowDeleteModal(false)}
              >
                Cancel
              </button>
              <button
                className="delte-yes-btn custom-button"
                onClick={() => deleteData(modalData)}
              >
                Yes, delete it!
              </button>
            </div>
          </>
          ;
        </MobilePopUp>
      )}
    </>
  );
};

export default PSM_Matrix;
